import React from 'react';
import { useLocation } from 'react-router';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';

import { getCurrentUser, getRefreshToken } from '@app/redux/auth/auth.selectors';
import { getBranchEnvironment } from '@app/redux/branchEnvironment/branchEnvironment.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';

import { AnimatedRedirect } from '@components/transition/route';

import { getBranchRoutes } from '@utils/environment';

import useGenerateRoutePath from '../paths/useGenerateRoutePath';

function MatchCurrentBranchRoute({ children }: { children: JSX.Element }) {
	const { startRequest: logout } = useTriggeredRequest(AccountClientRequests.Auth.logout);
	const branchEnvironmentFromStore = useAppSelector(getBranchEnvironment);
	const refreshToken = useAppSelector(getRefreshToken);
	const currentUser = useAppSelector(getCurrentUser);
	const generateRoutePath = useGenerateRoutePath();
	const { pathname, search } = useLocation();

	const checkIfBranchExists = (id: number): boolean => {
		if (currentUser && currentUser.branches) {
			for (let i = 0; i < currentUser.branches.length; i++) {
				if (currentUser.branches[i].uma_id === id) {
					return true;
				}
			}
		}
		return false;
	};

	if (branchEnvironmentFromStore.is_branch_from_query_params) {
		const searchParams = new URLSearchParams(search);
		if (
			searchParams.get('branch_id') !== String(branchEnvironmentFromStore?.branch_id) ||
			searchParams.get('rep_id') !== String(branchEnvironmentFromStore?.rep_id) ||
			searchParams.get('auth_form_slug') !== branchEnvironmentFromStore?.auth_form_slug
		) {
			logout({ refresh_token: refreshToken });
			return <AnimatedRedirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />;
		} else {
			return checkIfBranchExists(Number(searchParams.get('branch_id'))) ? children : null;
		}
	} else {
		const params = pathname.split('/').filter(param => param !== '');
		const branchRouteParams = params[0];
		const repRouteParam = params[1];
		const branchEnvironment = getBranchRoutes().find(
			route => route.branch_route === branchRouteParams && route.rep_route === repRouteParam,
		);

		const userBranchEnvironment = getBranchRoutes().find(route => checkIfBranchExists(route.branch_id));
		if (!userBranchEnvironment) return null;

		return userBranchEnvironment.branch_id === branchEnvironment?.branch_id ? (
			children
		) : (
			<AnimatedRedirect to={generateRoutePath(RoutePaths.MAIN.APPLICATIONS)} />
		);
	}
}

export default MatchCurrentBranchRoute;
